class Menu {
  constructor() {
    this.$mainMenu   = $('.main-menu')
    this.$openMenu   = $('.open-menu')
    this.$nav        = $('.main-menu nav')
    this.$anchor     = $('.anchor')
  }
  toggleMenu() {
    this.constructor()

    this.$mainMenu
    .toggleClass('open')
  }
  followMe($window) {
    this.constructor()
    const windowScrollTop = $window.scrollTop()

    if(windowScrollTop >= 100) {
      this.$mainMenu
      .addClass('followme')
    } else {
      this.$mainMenu
      .removeClass('followme')
    }
  }
  anchor($el) {
    this.constructor()
    const $target = $($el.attr('href'))
    const targetOffset = $target.offset().top

    $('html, body')
    .animate({
      scrollTop: targetOffset - 50
    })
  }
  init() {
    this.constructor()
    const self = this

    this.$openMenu
    .on('click', function(event) {
      event.preventDefault()
      event.stopPropagation()
      self.toggleMenu()
    })

    this.$nav
    .on('click', function(event) {
      event.stopPropagation()
    })

    $(document)
    .on('click', function(event) {
      if(self.$mainMenu.hasClass('open')) {
        self.toggleMenu()
      }
    })

    self.followMe($(window))

    $(window)
    .on('scroll', function() {
      self.followMe($(this))
    })

    this.$anchor
    .on('click', function(event) {
      event.preventDefault()
      self.anchor($(this))
    })
  }
}

export default Menu



// WEBPACK FOOTER //
// ./resources/assets/js/utilities/src/menu.js